var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-date-picker",
    _vm._b(
      {
        ref: "datePicker",
        staticStyle: { "min-width": "0" },
        attrs: {
          value: _vm.innerDateValue,
          allowClear: "",
          format: _vm.dateFormat,
          showTime: _vm.isDatetime,
          dropdownClassName: "j-vxe-date-picker",
        },
        on: { change: _vm.handleChange },
      },
      "a-date-picker",
      _vm.cellProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }